import { ActionTree } from 'vuex'
import * as types from './types'
import { FlowFile } from '@appbase/libs/flowjs'

export default <ActionTree<file.state.FileState, RootState>>{
	[types.FILE_LIST](action, files: FlowFile[]) {
		action.commit(types.FILE_LIST, files)
	},

	[types.FILE_SELECT](action, options: file.FileSelectionOptions) {
		action.commit(types.FILE_SELECT, options)
	},

	[types.FILE_SELECT_ALL_TOGGLE](action) {
		action.commit(types.FILE_SELECT_ALL_TOGGLE)
	},
}
